import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectWorks } from '../../Api/selectors';
import { selectAddressTypes } from '../../Address/selectors';
import { StepperCreateHeader } from '../../Vehicles/pages/create/Header';
import {
  createCompany,
  initiateCompanyCreate,
  fetchCountries,
  updateCompanyProperties,
  setNewCompanyValue,
  fetchCompany,
} from '../actions';
import { REQUEST_COMPANY, REQUEST_COMPANY_PROPERTY_UPDATE } from '../constants';
import { selectCompanies, selectNewCompany, selectNewCompanyAddresses } from '../selectors';
import { CompanyCreateStep1 } from './FirstStep/FirstStep';
import { CompanyCreateStep2 } from './SecondStep/SecondStep';
import { CompanyCreateStep3 } from './ThirdStep/ThirdStep';
import { CompanyCreateStep4 } from './FourthStep/FourthStep';
import { CompanyCreateInfo } from './CompanyCreateInfoCard';
import { resetCompanyProperties } from '../helpers';
import { Loader } from '../../../components/Loader';
import cn from 'classnames';
import styles from './create.module.css';

const Container = styled.div`
  width: auto;

  .form-block {
    display: flex;
    align-items: flex-start;
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
    }
  }
`;

const STATE = {
  step: 1,
  resultId: null,
  addresses: [],
  stepperClickStep: null,
  stepperClick: false,
  showCompanyInfo: false,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
    this.props.fetchCountries();
  }

  componentDidUpdate(prevProps) {
    if (this.state.step === 5) {
      this.to(`/companies/${this.state.resultId}`);
    }
    if (this.state.step < prevProps.step) {
      this.to(`/companies/${this.state.resultId}/edit/${this.state.step}`);
    }
    prevProps.step < this.state.step && this.state.resultId
      ? this.to(`/companies/create/${this.state.step}/${this.state.resultId}`)
      : null;
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    const requestBodyTypes = { addressLine1: '', postcode: '', city: '', countryId: '', accountManagerId: '' };
    let addressTypeId = null;
    let newAddress = {};

    let prop = {
      properties: [],
      addresses: [...this.state.addresses, newAddress],
      accountManagerId: this.props.values.accountManagerId,
    };

    if (this.props.step === 1) {
      addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    }

    if (this.props.step === 2) {
      addressTypeId = this.props.addressTypes.filter(t => t.name === 'invoice')[0].id;
    }

    for (let i in this.props.values) {
      if (this.props.values[i] != '' && i != 'addresses' && !Object.keys(requestBodyTypes).includes(i)) {
        prop.properties.push({
          name: i,
          value: this.props.values[i],
        });
      }
    }

    for (let i in addressProps) {
      if (this.props.values[i] != '') {
        newAddress[i] = this.props.values[i];
        newAddress['typeId'] = addressTypeId;
      }
    }

    const resetTypes = resetCompanyProperties(this.props.step);

    if (this.props.step === 1) {
      let addresses = [];
      try {
        Object.keys(newAddress).length > 1 ? (addresses = [newAddress]) : null;
      } catch (e) {}
      this.props.create(prop.properties, addresses, prop.accountManagerId, [], result => {
        if (result.id) {
          this.setState(prevState => ({
            ...this.state,
            step: (prevState.step += 1),
            resultId: result.id,
            addresses: result.addresses,
          }));

          this.state.stepperClick
            ? this.to(`/companies/${result.id}/edit/${this.state.stepperClickStep}`)
            : this.to(`/companies/${result.id}/edit/${this.state.step}`);
        }
      });
    }
    if (this.props.step === 3) {
      this.setState(prevState => ({
        ...this.state,
        step: (prevState.step += 1),
      }));
      this.to(`/companies/create/${this.state.step}/${this.state.resultId}`);
    }
    if (this.props.step === 2) {
      this.props.patch(this.state.resultId, prop.properties, prop.addresses, result => {
        this.setState(prevState => ({
          ...this.state,
          step: (prevState.step += 1),
          addresses: result.addresses,
        }));
      });
    }
    if (this.props.step === 4) {
      this.props.fetchCompany(this.props.match.params.company_id, fetchResult => {
        fetchResult &&
          this.props.patch(this.state.resultId, prop.properties, fetchResult.addresses, result => {
            this.setState(prevState => ({
              ...this.state,
              step: (prevState.step += 1),
              addresses: result.addresses,
            }));
          });
      });
    }

    this.props.resetValues(resetTypes);
  }

  getStep(n) {
    n && this.setState({ stepperClickStep: n, stepperClick: true });
  }

  prevStep() {
    this.setState(prevState => ({
      ...this.state,
      step: prevState.step - 1,
    }));
  }

  nextStep() {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  }

  toggleCompanyInfo = () => {
    this.setState(prevState => ({ showCompanyInfo: !prevState.showCompanyInfo }));
  };

  render() {
    if (this.props.work) return <Loader small />;

    if (this.props.values.id) return <Loader small />;
    const flexBoxClass = cn(
      styles.flexBox,
      {
        [styles.flexBoxPage1]: this.state.step === 1,
      },
      'form-block',
    );

    return (
      <Container>
        <StepperCreateHeader
          steps_quantity={4}
          step={this.state.step}
          model={'company'}
          labelArr={['Company info', 'Financial data', 'Contacts', 'Transport locations']}
          onSave={this.save.bind(this)}
          getStep={this.getStep.bind(this)}
          onIncrement={this.prevStep.bind(this)}
          onDecrement={this.nextStep.bind(this)}
        />
        <div className={flexBoxClass}>
          {window.innerWidth <= 768 && this.state.step > 1 && (
            <div className={styles.buttonCompanyInfo}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.toggleCompanyInfo}>
                Company Info
              </ButtonComponent>
            </div>
          )}

          {this.state.showCompanyInfo && this.props.company_id && (
            <CompanyCreateInfo
              company_id={this.props.company_id}
              data={['company_type', 'name', 'surname', 'phone_number', 'company_email', 'email']}
            />
          )}

          {this.state.step === 1 && <CompanyCreateStep1 onSave={this.save.bind(this)} />}
          {this.state.step === 2 && (
            <CompanyCreateStep2 onSave={this.save.bind(this)} getPrevStep={this.prevStep.bind(this)} />
          )}
          {this.state.step === 3 && (
            <CompanyCreateStep3
              company_id={this.props.match.params.company_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.state.step === 4 && (
            <CompanyCreateStep4
              company_id={this.state.resultId}
              addresses={this.state.addresses}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.state.step > 1 && this.props.match.params.company_id && window.innerWidth > 769 && (
            <CompanyCreateInfo
              company_id={+this.props.match.params.company_id}
              data={['company_type', 'name', 'surname', 'phone_number', 'company_email', 'email']}
            />
          )}
        </div>
      </Container>
    );
  }
}

CompanyCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY, REQUEST_COMPANY_PROPERTY_UPDATE]),
    values: selectNewCompany(),
    addresses: selectNewCompanyAddresses(),
    addressTypes: selectAddressTypes(),
    allCompanies: selectCompanies(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateCompanyCreate());
    },
    create(properties, addresses, accountManagerId, options, callback) {
      dispatch(createCompany(properties, addresses, accountManagerId, options, callback));
    },
    patch(id, props, addresses, callback) {
      dispatch(updateCompanyProperties(id, props, addresses, callback));
    },
    fetchCountries() {
      dispatch(fetchCountries());
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    resetValues(values, name = null) {
      Object.keys(values)?.map(type => dispatch(setNewCompanyValue(type, '')));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreate = compose(withConnect, withRouter)(CompanyCreateComp);
